// @flow
export type SimProductPriceActionType =
  | {|
      type: 'FETCH_SIM_PRODUCT_PRICE',
    |}
  | {|
      type: 'FETCH_SIM_PRODUCT_PRICE_SUCCESS',
      payload: {|
        price: number,
      |},
    |}
  | {|
      type: 'FETCH_SIM_PRODUCT_PRICE_FAILURE',
      payload: {|
        error: any,
      |},
    |};

export function fetchSimProductPrice(): SimProductPriceActionType {
  return {
    type: 'FETCH_SIM_PRODUCT_PRICE',
  };
}

export const fetchSimProductPriceFailure = (error: any): SimProductPriceActionType => ({
  type: 'FETCH_SIM_PRODUCT_PRICE_FAILURE',
  payload: {
    error,
  },
});

export function fetchSimProductPriceSuccess(price: number): SimProductPriceActionType {
  return {
    type: 'FETCH_SIM_PRODUCT_PRICE_SUCCESS',
    payload: {
      price,
    },
  };
}
